import { RootState } from 'editor/src/store/index';

const getActivePreview = (state: RootState) => state.editorModules.preview.activePreview;

export default getActivePreview;
